import React from 'react';
import { ProcessesService } from '@/api/process';
import { useSelector } from './useSelector';

export type Process =
  | 'CRDA' // In store damages
  | 'CODA' // Confirm damages
  | 'BTST' // Back to stock
  | 'REOR' // Recall order
  | 'REPR' // Repricing
  | 'INVT' // Inventory
  | 'INVP'
  | 'CSRT' // Customer returns
  | 'SLEX' // Sales exception
  | 'RTPS' // Return pos
  | 'CPOS' // Confirm PoS Checkout
  | 'MSUP' // Manual store upload
  | 'RSUP' // Reader store upload
  | 'DSUP' // Delete store upload
  | 'VSUP' // Vas store upload
  | 'CYCO' // CycleCount
  | 'SOHA' // Soh on hand alignment
  | 'CHLI' // Checkout light
  | 'BIS' // Back in Stock
  | 'MNDL' // Manage Delivery
  | 'RCC' // Receiving
  | 'RCP' // Partial Receiving
  | 'S2S' // Store to Store
  | 'RURL' // Remove user roles
  | 'STSM' // Stock Summary
  | 'PRNT'; // Print new tag

type HandleProcessBody = {
  process: Process;
  isLocked: boolean;
  lockedBy?: string;
};

type ReturnType = (body: HandleProcessBody) => Promise<void>;

const useHandleProcess = (): ReturnType => {
  const storeCode = useSelector(
    state => state.currentStore.store?.storeCode || ''
  );

  const handleProcess = React.useCallback(
    async ({ process, isLocked, lockedBy }: HandleProcessBody) => {
      await ProcessesService.handlingProcessStatus({
        requestBody: {
          isLocked,
          process,
          storeCode,
          lockedBy,
        },
      });
    },
    [storeCode]
  );

  return handleProcess;
};

export default useHandleProcess;
